/**
 * @description  Queuing websocket update status on /user/queuing/update
 */

export default Object.freeze({
  ADDED: 'ADDED', // added in queue
  ABANDONED: 'ABANDONED', // no place in queue
  POSITION_FORWARDED: 'POSITION_FORWARDED', // update message position
  REMOVED: 'REMOVED', // no agent available any more
  DISTRIBUTED: 'DISTRIBUTED', // distributed to agent
  CLOSED: 'CLOSED', // distributed to agent but closed when user come back
})
